import StoreInstances, { getStoreFor } from 'Stores/StoreInstances'
import BaseStore from 'Stores/base_store/BaseStore'
import { action } from 'mobx'
import Attachments from 'DataServices/Attachments'

const STORE_TYPE = 'Attachments'

export function getAttachmentsStoreFor (param, preload) {
  return getStoreFor(AttachmentsStore, STORE_TYPE, param, false, preload)
}

export class AttachmentsStore extends BaseStore {
  constructor (seedData) {
    const opts = {
      paginate: false,
    }
    super(STORE_TYPE, seedData, opts)
  }

  @action
  _fetchAll (overridePayload) {
    let payload = overridePayload || {
      ...this._filter,
    }
    return Attachments.getAll(payload)
  }

  @action
  _fetchOne (id) {
    return Attachments.getById({ id: this._filter.id })
  }

  @action
  update (attachment) {
    let payload = {
      ...attachment,
    }
    return Attachments.update(payload)
      .then(attachment => StoreInstances._propagateChanges(STORE_TYPE, [attachment]))
  }

  destroy (attachment) {
    let payload = {
      id: attachment.id,
    }
    return Attachments.destroy(payload)
      .then(attachment => StoreInstances._propagateChanges(STORE_TYPE, [attachment]))
  }
}
